module.exports = __webpack_public_path__ + "static/media/bookmark-blue.11ecb666.svg";